import * as React from 'react';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { shadowElevationZ2 } from '../../style/effects';
import { toolbarTextColor, toolbarBackgroundColor, toolbarSize } from '../../style/values';
import { zIndex } from '../../constants';

interface PrimaryToolbarProps {
  readonly direction: ToolbarDirection;
}

const headerStyle: React.CSSProperties = {
  ...shadowElevationZ2,
  color: toolbarTextColor,
  backgroundColor: toolbarBackgroundColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  zIndex: zIndex.primaryToolbar,
};

const PrimaryToolbar: React.SFC<PrimaryToolbarProps> = (props) => {
  const isVertical = (props.direction !== ToolbarDirection.Horizontal);

  const flexDirectionStyle: React.CSSProperties =
    isVertical ? { flexDirection: 'column', width: `${toolbarSize}px` }
               : { flexDirection: 'row', height: `${toolbarSize}px` };

  const headerBoundsStyle =
    isVertical ? { ...flexDirectionStyle, bottom: 0 }
               : { ...flexDirectionStyle, right: 0 };

  return (
    <header style={{ ...headerStyle, ...headerBoundsStyle }}>
      {props.children}
    </header>
  );
};

export default PrimaryToolbar;
